import React from 'react';
import { Router, Route, Switch } from 'react-router-dom';
import { createRoot } from 'react-dom/client';

import history from '../../common/utils/history';

import ScrollToTop from './components/ScrollToTop';
import { useRecaptchaLoader } from './hooks';
import Job from './job';
import Submit from './submit';
import Top from './top';

const RecruitApp = () => {
  // Preload reCAPTCHA at the app root so it's ready by the Submit page
  useRecaptchaLoader();
  return (
    <Router history={history}>
      <ScrollToTop />
      <Switch>
        <Route exact path="/recruit" component={Top} />
        <Route path="/recruit/job/:positionId" component={Job} />
        <Route path="/recruit/submit/:positionId" component={Submit} />
        {/* Fallback: unknown paths go to the top page */}
        <Route path="*" component={Top} />
      </Switch>
    </Router>
  );
};

const root = createRoot(document.getElementById('root'));
root.render(<RecruitApp />);
